import type { RequestRow } from "../requestLogGridTypes";

import { Skeleton } from "@/components/ui/skeleton";

export const HydrationPendingCell = () => <Skeleton width="70%" height="0.875rem" />;

export const isRequestRowHydrating = (data: RequestRow | undefined): boolean =>
  data?.hydration_status === "pending";
